<template>
  <b-container fluid>
    <b-row v-if="success">
      <p class="text-center">
        Login successful, please wait...
      </p>
    </b-row>
    <b-row v-else="true">
      <b-col md="6">
        <b-card :title="title">
          <b-form v-on:submit.prevent.stop="submit">
            <b-form-group id="email_label" label="Email" label-for="email">
              <b-input id="email" type="email" v-model="user.email" required></b-input>
            </b-form-group>
            <b-form-group id="password_label" label="Password" label-for="password">
              <b-input id="password" type="password" v-model="user.password" required></b-input>
            </b-form-group>
            <b-alert variant="danger" :show="errorMessage != null">{{errorMessage}}</b-alert>
            <div class="text-right">
              <b-button variant="link" :to="forgotPasswordLink">Forgot Password?</b-button>
              <b-button v-if="!oauth" href="https://www.vosvoco.com/">Cancel</b-button>
              <b-button type="submit" variant="primary">Log In</b-button>
            </div>
          </b-form>
          <h5>Don't have an account yet?</h5>
          <p>
            If you have received an invitation email to join Vos Voco, please follow the instructions in the email to create your account.
          </p>
          <p>
            To try Vos Voco, or for more information, please
            <a href="https://www.vosvoco.com/contact">get in touch</a>.
          </p>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import API from '@/lib/api'

const WEB_CLIENT_ID = 'gs9yoVyinLyZyGdHr_A0FNBJQ5fTMBCza_D1Nd_FlI3guadwAwJp9mqyssp-aa1-UucarTatKystO0o1w4eWkg'

export default {
  name: 'Login',
  data () {
    return {
      user: { email: '', password: '' },
      success: false,
      errorMessage: null
    }
  },
  props: {
    oauth: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    title: function () {
      if (this.oauth) {
        return null
      } else {
        return 'Log In to My Vos Voco'
      }
    },
    forgotPasswordLink: function () {
      if (this.oauth) {
        return {
          path: '/oauth/password/forgot',
          query: this.$route.query
        }
      } else {
        return '/account/password/forgot'
      }
    }
  },
  methods: {
    submit: function () {
      this.errorMessage = null
      var params = {
        username: this.user.email,
        password: this.user.password,
        grant_type: 'password',
        client_id: WEB_CLIENT_ID
      }
      if (this.oauth) {
        params['client_id'] = this.$route.query.client_id
        params['grant_type'] = 'redirect'
        params['redirect_uri'] = this.$route.query.redirect_uri
        params['scope'] = this.$route.query.scope
        params['state'] = this.$route.query.state
      }
      API.postRaw('oauth/token', params)
        .then((response) => {
          console.log('got auth response')
          if (response.data != null) {
            console.log('got response data')
            if (this.oauth) {
              this.success = true
              console.log('redirect uri ' + response.data.uri)
              var uri = response.data.uri
              document.location = uri
            } else {
              this.$store.commit('login', response.data)
              if (this.$route.query.return_path != null) {
                this.$router.push({path: this.$route.query.return_path, query: this.$route.query.return_query})
              } else {
                this.$router.push('/')
              }
            }
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 400) {
            if (error.response.data != null && error.response.data.error_message != null) {
              this.errorMessage = error.response.data.error_message
            } else {
              this.errorMessage = 'Incorrect email or password, please try again.'
            }
          } else {
            this.errorMessage = 'Cannot contact the Vos Voco servers. Please check your network connection and try again.'
          }
          console.log(this.errorMessage)
        })
      console.log('submit')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue